const LOAD_SUCCESS = 'LOAD_SUCCESS';
const LOAD_FAILED = 'LOAD_FAILED';
const CHANGE_FILTER = 'CHANGE_FILTER';
const LOAD_FAILURE = 'LOAD_FAILURE';
export {
  LOAD_SUCCESS, LOAD_FAILED, CHANGE_FILTER, LOAD_FAILURE,
};
